import type { HTMLAttributes, ReactNode } from "react";
import "./EmptyState.css";

export interface EmptyStateProps extends Omit<
  HTMLAttributes<HTMLDivElement>,
  "title"
> {
  /** A 32px line glyph. Rendered in `--fc-text-tertiary`. */
  icon: ReactNode;
  title: string;
  /** One supporting line — never a paragraph (DESIGN.md §11). */
  description: ReactNode;
  /** One action, usually a primary `Button`. */
  action?: ReactNode;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  ...rest
}: EmptyStateProps) {
  const classes = ["fc-empty", className]
    .filter((value): value is string => Boolean(value))
    .join(" ");

  return (
    <div {...rest} className={classes}>
      {icon !== undefined && icon !== null ? (
        <span className="fc-empty__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}

      <h2 className="fc-empty__title">{title}</h2>

      {description !== undefined && description !== null ? (
        <p className="fc-empty__description">{description}</p>
      ) : null}

      {action !== undefined && action !== null ? (
        <div className="fc-empty__action">{action}</div>
      ) : null}
    </div>
  );
}
